var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hori-screen-container"},[_c('i',{staticClass:"icon-lily icon-lily-hengping"}),_c('h1',[_vm._v("请横屏使用网站")])])
}]

export { render, staticRenderFns }